import { render, staticRenderFns } from "./goodNewsPopup.vue?vue&type=template&id=4936d0ee&scoped=true"
import script from "./goodNewsPopup.vue?vue&type=script&lang=js"
export * from "./goodNewsPopup.vue?vue&type=script&lang=js"
import style0 from "./goodNewsPopup.vue?vue&type=style&index=0&id=4936d0ee&lang=scss&scoped=true"
import style1 from "./goodNewsPopup.vue?vue&type=style&index=1&id=4936d0ee&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4936d0ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4936d0ee')) {
      api.createRecord('4936d0ee', component.options)
    } else {
      api.reload('4936d0ee', component.options)
    }
    module.hot.accept("./goodNewsPopup.vue?vue&type=template&id=4936d0ee&scoped=true", function () {
      api.rerender('4936d0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goodNewsPopup/goodNewsPopup.vue"
export default component.exports